import React, { useState, useContext } from 'react';
import { Menu, Breadcrumb, Header, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import UserContext from 'contexts/UserContext';

import {
  ProfileSettings,
  PasswordSettings,
  AccountSettings,
  AssistantSettings
} from 'components/Settings';


const settingsMap = {
  profile: <ProfileSettings />,
  password: <PasswordSettings />,
  account: <AccountSettings />,
  assistants: <AssistantSettings />
};

const SettingsPage = () => {
  const [activeItem, setActiveItem] = useState(() => window.location.hash ? window.location.hash.slice(1) : 'profile');
  const user = useContext(UserContext);

  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section><Link to="/">Home</Link></Breadcrumb.Section>
        <Breadcrumb.Divider icon='right angle' />
        <Breadcrumb.Section active>My Settings</Breadcrumb.Section>
      </Breadcrumb>

      <Header as="h2" dividing>My Settings</Header>
      <Grid columns={2} divided>
        <Grid.Row>
          <Grid.Column mobile={6} tablet={4} computer={4}>
            <Menu secondary vertical fluid>
              <Menu.Item
                name='Profile'
                active={activeItem === 'profile'}
                onClick={() => setActiveItem('profile')}
              />
              <Menu.Item
                name='Password'
                active={activeItem === 'password'}
                onClick={() => setActiveItem('password')}
              />
              {user.isTeacher ? (
                <>
                <Menu.Item
                  name='Subscription'
                  active={activeItem === 'account'}
                  onClick={() => setActiveItem('account')}
                />
                <Menu.Item
                  name='My Support Staff'
                  active={activeItem === 'assistants'}
                  onClick={() => setActiveItem('assistants')}
                />
                </>
              ) : null }
            </Menu>
          </Grid.Column>
          <Grid.Column mobile={10} tablet={12} computer={12}>
            {settingsMap[activeItem]}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default SettingsPage;
